import React from 'react';
import userdata from '../config/jwt_token'
import {Select, MenuItem, ListItemText} from '@material-ui/core'
import { getStatesAndCities } from '../utils/VendorApiUtils'

class CitySelect extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            cities:[],
            userCity: '',
            rolesWithCityFilter: ['Super Central Finance', 'Central Finance', 'Vendor Approver L2', 'root', 'Report Viewer'] //future roles can be added here
        }
    }
    componentDidMount() {
        // Guard: if userdata.city isn't populated yet, skip initialization
        if (!userdata || !userdata.city || !Array.isArray(userdata.city) || userdata.city.length === 0) {
            return;
        }
        const selectedCity = localStorage.getItem('selected_city');
        const userCity = userdata.city[0];//initialize with the user's city before changing if conditions are met

        // This is to set the City Filter to 'all cities' for the central finance logins by default
        if (!selectedCity) {
            if (this.state.rolesWithCityFilter.includes(userdata.role)) {
                localStorage.setItem('selected_city', 'all_cities');
                this.setState({
                    userCity: 'all_cities',
                    cities: userdata.city,
                });
            } else {
                localStorage.setItem('selected_city', userCity.city_name);
                this.setState({
                    userCity: userCity.city_name,
                    cities: userdata.city,
                });
            }
        } else {
            const newUserCity = this.state.rolesWithCityFilter.includes(userdata.role)
                ? selectedCity !== userCity.city_name
                    ? selectedCity
                    : userCity.city_name
                : selectedCity;
            localStorage.setItem('selected_city', newUserCity);
            this.setState({
                userCity: newUserCity,
                cities: userdata.city,
            });
        }
        // getStatesAndCities().then((response) => {
        //     if (response && response.status === 'success') {
        //         this.setState({ cities: response.data })
        //     }
        // })
    }

    handleChange(event) {
        this.setState({
            userCity: event.target.value,
          }, () => {localStorage.setItem('selected_city', this.state.userCity);
          window.location.reload();
        });
      }

    render() {
        return (
            <div style={{ fontSize: '13px', fontFamily: "'Inter', sans-serif", marginBottom: '0px' }}>
                {/* { this.state.rolesWithCityFilter.indexOf(userdata.role) === -1 ?
                <div>
                    <span style={{ paddingLeft: '20px' }}>{userdata.city}</span>
                </div>:
                } */}
                <div>
                    <Select
                        value={this.state.userCity}
                        onChange={(e) => this.handleChange(e)}
                        style={{ textAlign: 'left', background: 'rgba(255,255,255,0.12)', color: '#f1f5f9', paddingLeft: '8px', maxWidth: '140px', borderRadius: '6px', fontSize: '13px' }}
                        >
                        {this.state.rolesWithCityFilter.includes(userdata.role) && (
                            <MenuItem key={0} value={'all_cities'} ><ListItemText primary='All Cities' /></MenuItem>
                        )}
                        {
                            this.state.cities.map((city) => {
                            return <MenuItem key={city.city_id} value={city.city_name} ><ListItemText primary={city.city_name} /></MenuItem>
                            })
                        }
                    </Select>
                </div>
            </div>
        );
    }
}

  export default CitySelect


// WEBPACK FOOTER //
// ./src/components/CitySelect.js